import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { VlmTabToggles } from "./VlmTabToggles";

export const VlmTab = () => {
  const { vlmSettings, vlmCustomCase, vlmConfigLoading } = useEditCameraStore();

  if (vlmConfigLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress color="warning" />
      </Box>
    );
  }

  return (
    <VlmTabToggles
      settings={vlmSettings}
      customAnalysisName={vlmCustomCase}
      disabled={true}
    />
  );
};
